module.exports = __webpack_public_path__ + "static/media/cube.73418c40.png";